import { fabric } from 'fabric';
import {
  getGradientAngleFromFabricGradientCoords,
  getFabricGradient,
} from '../gradients';

const stateProperties = fabric.Rect.prototype.stateProperties.concat();
stateProperties.push('innerStroke', 'innerStrokeWidth');

const cacheProperties = fabric.Rect.prototype.cacheProperties.concat();
cacheProperties.push('innerStroke', 'innerStrokeWidth');

const LudusCircle = fabric.util.createClass(fabric.Ellipse, {
  type: 'ludusCircle',

  innerStroke: null,
  innerStrokeWidth: 0,
  strokeMiterLimit: 0,
  stateProperties,
  cacheProperties,
  fill: null,
  radius: 100,

  startAngle: 0,
  /**
   * End angle of the circle
   * deprectated type, this should be in degree, this was an oversight.
   * probably will change to degrees in next major version
   * @type Number
   * @default 2Pi
   */
  endAngle: Math.PI * 2,

  initialize(options) {
    const optionsFixed = {
      ...options,
      ludus: { ...options.ludus, type: 'circle' },
    };

    if (options.innerStrokeWidth) {
      optionsFixed.strokeWidth = options.innerStrokeWidth;
      delete optionsFixed.innerStrokeWidth;
    }
    if (options.innerStroke) {
      optionsFixed.stroke = options.innerStroke;
      delete optionsFixed.innerStroke;
    }

    this.callSuper('initialize', optionsFixed);
    this.on('scaling', this.onScaling.bind(this));
    this.initialized = true;
  },

  getMaxInnerStrokeWidth() {
    const groupScale = this.getObjectScaling();
    const maxInnerStrokeWidthH = this.radius * groupScale.scaleX;
    const maxInnerStrokeWidthV = this.radius * groupScale.scaleY;
    return Math.min(maxInnerStrokeWidthH, maxInnerStrokeWidthV);
  },

  applyGroupScale() {
    if (this.group) {
      const scale =
        this.group.scaleX > this.group.scaleY
          ? this.group.scaleY
          : this.group.scaleX;
      this.set({ strokeWidth: this.strokeWidth * scale });
    }
  },

  onScaling() {
    this.setCoords();
  },

  _set(key, value) {
    if (!this.initialized) {
      this.callSuper('_set', key, value);
      return this;
    }

    let newValue = value;

    if (key === 'innerStrokeWidth') {
      const maxInnerStrokeWidth = this.getMaxInnerStrokeWidth();
      newValue = Math.min(value, maxInnerStrokeWidth);
      this.strokeWidth = newValue;
    }
    if (key === 'innerStroke') {
      this.stroke = value;
    }
    // ellipse don't care of height & widht, only radiuses
    if (key === 'height') {
      this.ry = value / 2;
    }

    if (key === 'width') {
      this.rx = value / 2;
    }

    this.callSuper('_set', key, newValue);

    return this;
  },

  setCoords(ignoreZoom, skipAbsolute) {
    const coords = this.callSuper('setCoords', ignoreZoom, skipAbsolute);
    this.updateGradient();
    return coords;
  },

  updateGradient(offsetX = 0, offsetY = 0, width, height) {
    if (!this.fill || !this.fill.coords) {
      return;
    }
    const angle = getGradientAngleFromFabricGradientCoords(this.fill.coords);
    const gradient = getFabricGradient(
      {
        ...this.fill,
        angle,
      },
      width || this.width,
      height || this.height,
      offsetX,
      offsetY,
    );
    this.fill = gradient;
  },

  _render(ctx) {
    const skipGroup = this.group && this.group.type === 'ludusPathGroup';
    const matrix = this.calcTransformMatrix(skipGroup);
    const invertMatrix = fabric.util.invertTransform(matrix);
    const options = fabric.util.qrDecompose(matrix);

    const strokeWidth =
      this.stroke && this.stroke !== 'transparent' ? this.strokeWidth : 0;

    const rx = this.width - strokeWidth / options.scaleX;
    const ry = this.height - strokeWidth / options.scaleY;

    // const angleOffset = this.angle > 0 ? 90 * (Math.PI / 180) : 0;
    const angleOffset = 0 * (Math.PI / 180);
    const startAngle = this.startAngle - angleOffset;
    const endAngle = this.endAngle - angleOffset;

    ctx.save();

    ctx.beginPath();
    // scale it to include strokeWdith in the bbox
    ctx.transform(rx / this.width, 0, 0, ry / this.height, 0, 0);
    ctx.ellipse(
      0,
      0,
      this.width / 2,
      this.height / 2,
      0,
      startAngle,
      endAngle,
      false,
    );
    if (this.fill) {
      ctx.fill();
    }
    ctx.restore();
    if (this.stroke && this.strokeWidth > 0) {
      ctx.save();
      ctx.lineCap = 'round';
      ctx.transform(
        invertMatrix[0],
        invertMatrix[1],
        invertMatrix[2],
        invertMatrix[3],
        0,
        0,
      );
      if (this.strokeDashArray) {
        ctx.setLineDash(this.strokeDashArray);
      } else {
        ctx.setLineDash([0]);
      }
      ctx.shadowColor = 'transparent';
      ctx.stroke();
      ctx.restore();
    }
  },

  /**
   * Returns svg representation of an instance
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */

  _toSVG() {
    const transformMatrix = [...this.ludus.transformMatrix];
    const options = fabric.util.qrDecompose(transformMatrix);
    const width = this.width * options.scaleX;
    const height = this.height * options.scaleY;
    this.width = width;
    this.height = height;
    this.angle = options.angle;
    this.scaleX = 1;
    this.scaleY = 1;
    this.setPositionByOrigin(
      {
        x: options.translateX,
        y: options.translateY,
      },
      'center',
      'center',
    );

    // as we changed the scale and width we must recompute it to the gradient
    // even if this gradient has no gradientTransform
    if (this.fill && this.fill.colorStops) {
      this.fill.gradientTransform = [
        options.scaleX,
        0,
        0,
        options.scaleY,
        width / 2,
        height / 2,
      ];
    }
    const strokeWidth =
      this.stroke && this.stroke !== 'transparent' && this.strokeWidth
        ? this.strokeWidth
        : 0;
    return [
      '<ellipse ',
      'COMMON_PARTS',
      'cx="0" cy="0" ',
      'rx="',
      (this.width - strokeWidth) / 2,
      '" ry="',
      (this.height - strokeWidth) / 2,
      '" />\n',
    ];
  },
});

LudusCircle.fromObject = function fromObject(object, callback) {
  const options = fabric.util.object.clone(object, true);

  if (callback) callback(new LudusCircle(options));
};

LudusCircle.fromElement = function(element, callback) {
  const type = element.tagName === 'circle' ? 'Circle' : 'Ellipse';

  var parsedAttributes = fabric.parseAttributes(
    element,
    fabric[type].ATTRIBUTE_NAMES,
  );

  if (type === 'Ellipse') {
    parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.rx;
    parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.ry;
    callback(new fabric.LudusCircle(parsedAttributes));
  } else {
    parsedAttributes.left =
      (parsedAttributes.left || 0) - parsedAttributes.radius;
    parsedAttributes.top =
      (parsedAttributes.top || 0) - parsedAttributes.radius;
    callback(
      new fabric.LudusCircle({
        ...parsedAttributes,
        rx: parsedAttributes.radius,
        ry: parsedAttributes.radius,
      }),
    );
  }
};

export default LudusCircle;
